import React from "react";

const Stat_Populations_And_Samples = () => {
  return (
    <div>
      <h1>Stat Populations & Samples</h1>
    </div>
  );
};

export default Stat_Populations_And_Samples;
